<script>
	import Dispatch from '../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'
  import playTime from '../engines/clock'

	const playReaderPosition = playTime
		.pipe(
			withLatestFrom(Dispatch.getState('view.scale.windowWidth'), Dispatch.getState('view.scale.songLength')),
			map(e =>  (e[0] * e[1])/e[2] ),
			tap(e => {
				const element = document.getElementById('scripter')
				element.scrollTo({left: e - window.innerWidth/2 })
			})
		)
</script>

<div class='absolute bg-dark-red h-100' style={'z-index: 10000; width: 2px; left: ' + $playReaderPosition + 'px'}></div>

<style>
</style>